import React from 'react'
import PropTypes from 'prop-types'

const InFlagIcon = ({ size = 34 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <g clipPath="url(#clip0_3961_24449)">
        <path
          d="M0 17V29.6692C0.000426203 30.5447 0.267306 31.3991 0.765023 32.1187C1.01938 32.4797 1.32486 32.8017 1.67186 33.0744C2.42678 33.6692 3.35886 33.9935 4.31932 33.9957H29.6764C30.8135 33.9867 31.9014 33.5302 32.7055 32.7248C33.5095 31.9195 33.9652 30.8297 33.9742 29.6908V16.9225H0V17Z"
          fill="#F2F2F2"
        />
        <path
          d="M29.6935 3.12585e-06H4.33639C3.37406 -0.00116213 2.43958 0.323492 1.68464 0.921255C0.793753 1.61786 0.210587 2.63618 0.0600575 3.75816C0.032599 3.94635 0.0182488 4.13623 0.0170898 4.32641V16.9225H34.0042V4.32641C33.9952 3.18747 33.5395 2.09772 32.7355 1.29234C31.9314 0.486957 30.8434 0.0305262 29.7064 0.0215223L29.6935 3.12585e-06Z"
          fill="#E10E00"
        />
      </g>
      <defs>
        <clipPath id="clip0_3961_24449">
          <rect width="34" height="34" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

InFlagIcon.propTypes = {
  size: PropTypes.string,
}

export default InFlagIcon
